$(document).ready(function(){
  
   var $status = $('.js-pagingInfo');
  var $slickElement = $('.js-number-slider');

	$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
	  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    // console.log('inside')
	  var i = (currentSlide ? currentSlide : 0) + 1;
	  $status.text(i + ' / ' + slick.slideCount);
	});

  $('.js-header-slider').slick({
  	dots: true,
  	appendArrows:'.c-slick-controls',
  	appendDots:'.c-slick-controls',
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $('.js-number-slider').slick({
  	appendArrows:'.c-slick-controls',
  	appendDots:'.c-slick-controls',
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $('.js-advisory-slider').slick({
    // appendArrows:'.c-advisory-slick-controls',
    autoplay: true,
    fade:true,
    autoplaySpeed: 5000,
    arrows:false,
  });
});